import Tag from '@Components/Common/Tag';
import {
    Avatar,
    Box,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Typography,
} from '@mui/material';
import { Link } from '@tanstack/react-router';
// import { Link } from '@tanstack/react-router';

type ViewListItemProps = {
    onClick?: () => void;
    to?: string;
    avatarSrc?: string;
    avatar?: React.ReactNode;
    title: string;
    description?: string;
    metaText?: string;
    height?: number;
    tags?: React.ReactNode;
};

const ViewListItem: React.FC<ViewListItemProps> = ({
    onClick,
    to,
    avatar,
    title,
    description,
    metaText,
    height = 80,
    tags,
}) => {
    return (
        <ListItemButton
            LinkComponent={onClick ? undefined : Link}
            to={to}
            sx={{
                // height: height + 24,
                paddingY: 1.5,
                paddingX: 2,
                borderRadius: 0,
            }}
        >
            {avatar && (
                <ListItemAvatar
                    sx={{
                        width: height,
                        height: height,
                        borderRadius: theme => theme.shape.lg,
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pr: 2,
                    }}
                >
                    {avatar}
                </ListItemAvatar>
            )}
            <ListItemText
                primary={title}
                primaryTypographyProps={{
                    variant: 'titleLarge',
                    marginBottom: 0.5,
                }}
                secondary={
                    <>
                        <Box>
                            <Typography variant="bodyMedium" noWrap>
                                {description}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography
                                variant="bodyMedium"
                                color="onSurfaceVariant.main"
                                sx={{ alignSelf: 'flex-end' }}
                            >
                                {metaText}
                            </Typography>
                        </Box>
                    </>
                }
                secondaryTypographyProps={{
                    component: Box,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flex: 1,
                }}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    // py: 0.75,
                    // mt: 0,
                    mt: 0.75,
                    mb: 'auto',
                }}
            />
            <Box display="flex" gap={1} alignSelf="flex-start">
                {tags}
            </Box>
        </ListItemButton>
    );
};

export default ViewListItem;
